module.exports = __webpack_public_path__ + "img/cardCharacterFrame.49ed9ade.png";